import Model from "../model";
import { request } from "/app/src/lib";
import * as actions from "./actions";
import { toast } from "react-toastify";

class Company extends Model {
  fetchCompany(companyId) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/company`)
        .accept("application/json")
        .send({ company_id: companyId })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              dispatch(actions.setCompanyInfo(res.body.company));
              break;
            default:
              return;
          }
        });
    };
  }
  companiesOverviewPost() {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/companies`)
        .accept("application/json")
        .send({})
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              dispatch(actions.setCompaniesInfo(res.body.companies));
              break;
            default:
              return;
          }
        });
    };
  }
  updatePaymentStatus(companyId, paymentStatus, info) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/company/payment/update`)
        .accept("application/json")
        .send({
          company_id: companyId,
          payment_status: paymentStatus,
          info: info,
        })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              dispatch(this.fetchCompany(companyId));
              break;
            default:
              return;
          }
        });
    };
  }
  setTrialDate(companyId, date) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/company/payment/changetrialdate`)
        .accept("application/json")
        .send({
          company_id: companyId,
          date: date,
        })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              dispatch(this.fetchCompany(companyId));
              break;
            default:
              return;
          }
        });
    };
  }
  updateEmployee(employeeId, companyId, updates) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/employee/update`)
        .accept("application/json")
        .send({ employee_id: employeeId, updates: updates })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              dispatch(this.fetchCompany(companyId));
              toast.success("Employee updated");
              break;
            default:
              return;
          }
        });
    };
  }
  resetPassword(employeeId, optionalEmail, companyId) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/employee/reset_password`)
        .accept("application/json")
        .send({ employee_id: employeeId, email: optionalEmail })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              toast.info("new password: " + res.body.password, {
                autoClose: false,
                closeOnClick: false,
              });
              dispatch(this.fetchCompany(companyId));
              break;
            default:
              return;
          }
        });
    };
  }
  verifyEmail(employeeId, optionalEmail, companyId) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/employee/verification`)
        .accept("application/json")
        .send({ employee_id: employeeId, email: optionalEmail })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              toast.info("new password: " + res.body.password, {
                autoClose: false,
                closeOnClick: false,
              });
              dispatch(this.fetchCompany(companyId));
              break;
            default:
              return;
          }
        });
    };
  }

  deleteEmployee(employeeId, companyId) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/employee/delete`)
        .accept("application/json")
        .send({ employee_id: employeeId })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              dispatch(this.fetchCompany(companyId));
              break;
            default:
              return;
          }
        });
    };
  }
  delete(companyId) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      request
        .post(`${url}/admin/company/delete`)
        .accept("application/json")
        .send({ company_id: companyId })
        .set("Authorization", "Bearer " + token)
        .end((err, res) => {
          switch (res.statusCode) {
            case 200:
              dispatch(actions.deleteCompany(companyId));
              toast.success("Company deleted");
              break;
            default:
              return;
          }
        });
    };
  }
}

export default new Company();



// WEBPACK FOOTER //
// src/model/Company/model.js